let _ = t => t,
  _t,
  _t2,
  _t3,
  _t4,
  _t5,
  _t6,
  _t7,
  _t8,
  _t9,
  _t10;
import styled from 'styled-components';
import { X } from '@ovpn-ui/icons';
import { colors } from '@ovpn-ui/styles';
import { fontStack, fontWeights } from '../styles';
const BaseBanner = styled.aside(_t || (_t = _`
    display: flex;
    gap: 16px;

    width: 100%;

    padding: 16px;

    font-size: ${0};
    line-height: ${0};
    letter-spacing: ${0};

    border-style: solid;
    border-width: 1px;
    border-radius: 8px;
`), fontStack.textSm.fontSize, fontStack.textSm.lineHeight, fontStack.textSm.letterSpacing);
export const InfoBanner = styled(BaseBanner)(_t2 || (_t2 = _`
    background-color: ${0};
    border-color: ${0};
`), colors.neutralBg, colors.neutralBorderHover);
export const SuccessBanner = styled(BaseBanner)(_t3 || (_t3 = _`
    background-color: ${0};
    border-color: ${0};
`), colors.successLight, colors.successLightActive);
export const AttentionBanner = styled(BaseBanner)(_t4 || (_t4 = _`
    background-color: ${0};
    border-color: ${0};
`), colors.attentionLight, colors.attentionBase);
export const WarningBanner = styled(BaseBanner)(_t5 || (_t5 = _`
    background-color: ${0};
    border-color: ${0};
`), colors.warningLight, colors.warningLightActive);
export const Container = styled.div(_t6 || (_t6 = _`
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    width: 100%;
`));
export const Header = styled.header(_t7 || (_t7 = _`
    display: flex;
    align-items: center;
    justify-content: space-between;

    color: ${0};
    font-weight: ${0};
`), colors.neutralTextTitle, fontWeights.medium);
export const Content = styled.div(_t8 || (_t8 = _`
    margin-top: 8px;
`));
export const Footer = styled.footer(_t9 || (_t9 = _`
    display: flex;
    gap: 16px;

    margin-top: 8px;
`));
export const CloseIcon = styled(X)(_t10 || (_t10 = _`
    color: ${0};

    cursor: pointer;
`), colors.neutralTextTitle);